import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, Redirect, useHistory, useLocation } from "react-router-dom";
import { fetchSuppliers } from "../../services/assortiment/actions.js";
import {
	changeLocation,
	changeProductgroup,
	changeSupplier,
} from "../../services/currentInformation/actions.js";
import { loginAPI, loginWithKey } from "../../services/login/actions";
import "./LoginForm.scss";

function Login(props) {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [urlToken, setUrlToken] = useState(
		new URLSearchParams(window.location.search).get("key")
	);
	const [loading, setLoading] = useState(true);

	const location = useLocation();
	const history = useHistory();

	const initializeData = async () => {
		await props.changeLocation(props.currentLocation);

		props.fetchSuppliers(props.currentLocation.id, props.userId);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		props.loginAPI(username, password);
	};

	if (props.loginSuccesful === "succesful" && urlToken == null) {
		initializeData();

		window.location.href =
			window.location.origin + window.location.pathname + window.location.hash; //not ideal but works to remove params
		if (props.farmers) {
			return <Redirect to="/home" />; //was farmersassortiment
		} else {
			return <Redirect to="/assortiment" />;
		}
	} else if (urlToken) {
		props.loginWithKey(urlToken).then(() => {
			const queryParams = new URLSearchParams(location.search);
			queryParams.delete("key");
			history.replace({
				search: queryParams.toString(),
			});
			setUrlToken(null); //to make it redirect with new key
		});
		return "";
	} else {
		return (
			<div className="LoginFormWrapper">
				<div className="LoginFormBackground"></div>
				<div className="LoginForm fadeIn">
					<div>
						<img src={props.identifyInfo.logo}></img>
					</div>
					<form onSubmit={handleSubmit}>
						<p>Welkom bij {props.identifyInfo.naam}</p>
						<input
							className="LoginFormInput"
							type="email"
							placeholder="Gebruikersnaam"
							onChange={(e) => setUsername(e.target.value)}
							required
							autoFocus
						/>
						<input
							className="LoginFormInput"
							type="password"
							placeholder="Wachtwoord"
							onChange={(e) => setPassword(e.target.value)}
							required
						/>
						<input className="LoginFormSubmit" type="submit" value="Inloggen" />
					</form>
					{props.identifyInfo.public ? (
						<Link
							style={{ textDecoration: "none", color: "black" }}
							to={{
								pathname: "/signup",
								state: { bottomnav: true },
							}}
						>
							<div
								style={{
									borderWidth: 1,
									borderColor: "grey",
									borderStyle: "solid",
									borderRadius: 3,
									padding: "10px 0",
									backgroundColor: "#ececec",
								}}
							>
								<p1>Maak een account aan...</p1>
							</div>
						</Link>
					) : null}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		loginSuccesful: state.login.data.loginSuccesful,
		loginLocation: state.login.current_location,
		userId: state.login.data.user_id,
		currentLocation: state.login.data.current_location,
		suppliers: state.assortiment.suppliers,
		currentSupplier: state.currentInformation.current_supplier,
		farmers: state.login.data.farmers,
		identifyInfo: state.identify.identifyInfo,
	};
}

export default connect(mapStateToProps, {
	loginAPI,
	loginWithKey,
	changeSupplier,
	changeProductgroup,
	changeLocation,
	fetchSuppliers,
})(Login);
